import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { showSaveToBoardToast } from "@faire/retailer-visitor-shared/features/RetailerBoards/Components/SaveToBoardToast";
import { updateBoardsCaches } from "@faire/retailer-visitor-shared/features/RetailerBoards/hooks/boardsHooks";
import { useProductCacheStore } from "@faire/retailer-visitor-shared/stores/domain/ProductCacheStore";
import { getRetailerToken } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import fetchSingleBoard from "@faire/web-api--source/api/v2/retailers/retailerToken/boards/boardToken/get";
import { getQueryKey as getFetchBoardQueryKey } from "@faire/web-api--source/api/v2/retailers/retailerToken/boards/boardToken/get-hooks";
import { useMutation as useCreateBoardItemMutation } from "@faire/web-api--source/api/v2/retailers/retailerToken/boards/boardToken/items-lean-product-tiles/post-hooks";
import { useMutation as useDeleteBoardItemMutation } from "@faire/web-api--source/api/v2/retailers/retailerToken/boards/boardToken/products/productToken/delete-hooks";
import { getQueryKey as getFetchBoardProductsByBrandQueryKey } from "@faire/web-api--source/api/v2/retailers/retailerToken/boards/boardToken/scroll/brands/brandToken/lean-product-tiles/get-hooks";
import { getQueryKey as getFetchBoardBrandsQueryKey } from "@faire/web-api--source/api/v2/retailers/retailerToken/boards/boardToken/scroll/brands/get-hooks";
import { getQueryKey as getFetchBoardProductsQueryKey } from "@faire/web-api--source/api/v2/retailers/retailerToken/boards/boardToken/scroll/lean-product-tiles/get-hooks";
import fetchDefaultBoard from "@faire/web-api--source/api/v2/retailers/retailerToken/boards/default/get";
import { getQueryKey as getFetchDefaultBoardQueryKey } from "@faire/web-api--source/api/v2/retailers/retailerToken/boards/default/get-hooks";
import { ICreateRetailerBoardItemRequest } from "@faire/web-api--source/indigofair/data/ICreateRetailerBoardItemRequest";
import { IGetBoardItemsGroupByBrandsScrollResponse } from "@faire/web-api--source/indigofair/data/IGetBoardItemsGroupByBrandsScrollResponse";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { IRetailerBoard } from "@faire/web-api--source/indigofair/data/IRetailerBoard";
import { useQueryClient } from "@tanstack/react-query";
import React from "react";
export var useSaveToBoard = function(onToastChangeBoardClick) {
    var addToBoard = useAddToBoard().addToBoard;
    var saveToBoard = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(productToken, boardTokenToUse, productImage, onUpdate) {
            var boardToken;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            addToBoard(productToken, boardTokenToUse, productImage, onUpdate)
                        ];
                    case 1:
                        boardToken = _state.sent().boardToken;
                        showSaveToBoardToast({
                            boardToken: boardToken,
                            productImage: productImage,
                            onChangeBoardClick: onToastChangeBoardClick
                        });
                        return [
                            2,
                            {
                                boardToken: boardToken
                            }
                        ];
                }
            });
        });
        return function(productToken, boardTokenToUse, productImage, onUpdate) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addToBoard,
        onToastChangeBoardClick
    ]);
    return {
        saveToBoard: saveToBoard
    };
};
var useAddToBoard = function() {
    var mutation = useCreateBoardItemMutation();
    var queryClient = useQueryClient();
    var retailerToken = getRetailerToken();
    var invalidateCache = useProductCacheStore([
        "invalidateCache"
    ]).invalidateCache;
    var addToBoard = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(productToken, boardToken, productImage, onUpdate) {
            var _response_item, _response_item1, _response_lean_brand, _response_lean_brand1, _response_item2, board, response, response1, request, _board_token, response2, _response_item_token, _board_items_count, _board_cover_images, _response_item_token1, _response_lean_brand_token;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!boardToken) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            queryClient.fetchQuery({
                                queryKey: getFetchDefaultBoardQueryKey(retailerToken),
                                queryFn: function() {
                                    return fetchDefaultBoard(retailerToken);
                                },
                                staleTime: 5 * 60 * 1000
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        board = response.board;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            queryClient.fetchQuery({
                                queryKey: getFetchBoardQueryKey(retailerToken, boardToken),
                                queryFn: function() {
                                    return fetchSingleBoard(retailerToken, boardToken);
                                },
                                staleTime: 5 * 60 * 1000
                            })
                        ];
                    case 3:
                        response1 = _state.sent();
                        board = response1 === null || response1 === void 0 ? void 0 : response1.board;
                        _state.label = 4;
                    case 4:
                        request = ICreateRetailerBoardItemRequest.build({
                            image_data: ICreateRetailerBoardItemRequest.IImageData.build({
                                url: productImage === null || productImage === void 0 ? void 0 : productImage.url
                            }),
                            product_token: productToken
                        });
                        return [
                            4,
                            mutation.mutateAsync([
                                retailerToken,
                                (_board_token = board === null || board === void 0 ? void 0 : board.token) !== null && _board_token !== void 0 ? _board_token : "",
                                request
                            ])
                        ];
                    case 5:
                        response2 = _state.sent();
                        updateBoardsCaches(queryClient, retailerToken, (_response_item_token = (_response_item = response2.item) === null || _response_item === void 0 ? void 0 : _response_item.token) !== null && _response_item_token !== void 0 ? _response_item_token : "", _object_spread_props(_object_spread({}, board), {
                            items_count: ((_board_items_count = board === null || board === void 0 ? void 0 : board.items_count) !== null && _board_items_count !== void 0 ? _board_items_count : 0) + 1,
                            cover_images: [
                                IImage.build(productImage)
                            ].concat(_to_consumable_array((_board_cover_images = board === null || board === void 0 ? void 0 : board.cover_images) !== null && _board_cover_images !== void 0 ? _board_cover_images : []))
                        }));
                        refetchBoardItemsQueries(queryClient, retailerToken, (_response_item_token1 = (_response_item1 = response2.item) === null || _response_item1 === void 0 ? void 0 : _response_item1.token) !== null && _response_item_token1 !== void 0 ? _response_item_token1 : "", (_response_lean_brand_token = (_response_lean_brand = response2.lean_brand) === null || _response_lean_brand === void 0 ? void 0 : _response_lean_brand.token) !== null && _response_lean_brand_token !== void 0 ? _response_lean_brand_token : "");
                        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
                            savedToBoardToken: board === null || board === void 0 ? void 0 : board.token
                        });
                        invalidateCache((_response_lean_brand1 = response2.lean_brand) === null || _response_lean_brand1 === void 0 ? void 0 : _response_lean_brand1.token, queryClient);
                        return [
                            2,
                            {
                                boardToken: (_response_item2 = response2.item) === null || _response_item2 === void 0 ? void 0 : _response_item2.token
                            }
                        ];
                }
            });
        });
        return function(productToken, boardToken, productImage, onUpdate) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutation,
        queryClient,
        retailerToken,
        invalidateCache
    ]);
    return {
        addToBoard: addToBoard
    };
};
export var useRemoveFromBoard = function() {
    var mutation = useDeleteBoardItemMutation();
    var queryClient = useQueryClient();
    var retailerToken = getRetailerToken();
    var invalidateCache = useProductCacheStore([
        "invalidateCache"
    ]).invalidateCache;
    var removeFromBoard = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(productToken, boardToken, brandToken, onUpdate) {
            var response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // we update the items cache before performing the request as an optimistic UI trick
                        updateBoardItemsCaches(queryClient, retailerToken, boardToken, brandToken !== null && brandToken !== void 0 ? brandToken : "", productToken);
                        // then we immediately fire onUpdate callback to show optimistic updated data to user
                        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
                            removedFromBoardToken: boardToken
                        });
                        return [
                            4,
                            mutation.mutateAsync([
                                retailerToken,
                                boardToken,
                                productToken
                            ])
                        ];
                    case 1:
                        response = _state.sent();
                        // we update the boards cache after the request to use fresh board data form the response
                        updateBoardsCaches(queryClient, retailerToken, boardToken, IRetailerBoard.build(response.retailer_board));
                        // then we fire onUpdate callback again without any token, just to get data in sync
                        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({});
                        invalidateCache(brandToken, queryClient);
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return function(productToken, boardToken, brandToken, onUpdate) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutation,
        queryClient,
        retailerToken,
        invalidateCache
    ]);
    return {
        removeFromBoard: removeFromBoard
    };
};
export var useMoveToBoard = function() {
    var addToBoard = useAddToBoard().addToBoard;
    var removeFromBoard = useRemoveFromBoard().removeFromBoard;
    var moveToBoard = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(productToken, brandToken, fromBoardToken, toBoardToken, productImage, onUpdate) {
            var boardToken;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            removeFromBoard(productToken, fromBoardToken, brandToken, onUpdate)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            addToBoard(productToken, toBoardToken, productImage, onUpdate)
                        ];
                    case 2:
                        boardToken = _state.sent().boardToken;
                        showSaveToBoardToast({
                            boardToken: boardToken,
                            productImage: productImage,
                            onChangeBoardClick: undefined,
                            boardItemIsMoving: true
                        });
                        return [
                            2,
                            {
                                boardToken: boardToken
                            }
                        ];
                }
            });
        });
        return function(productToken, brandToken, fromBoardToken, toBoardToken, productImage, onUpdate) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addToBoard,
        removeFromBoard
    ]);
    return {
        moveToBoard: moveToBoard
    };
};
var refetchBoardItemsQueries = function(queryClient, retailerToken, boardToken, brandToken) {
    queryClient.refetchQueries({
        queryKey: getFetchBoardProductsQueryKey(retailerToken, boardToken)
    });
    queryClient.refetchQueries({
        queryKey: getFetchBoardBrandsQueryKey(retailerToken, boardToken)
    });
    queryClient.refetchQueries({
        queryKey: getFetchBoardProductsByBrandQueryKey(retailerToken, boardToken, brandToken)
    });
};
var updateBoardItemsCaches = function(queryClient, retailerToken, boardToken, brandToken, productToken) {
    updateBoardProductsCache(queryClient, retailerToken, boardToken, productToken);
    updateBoardBrandsCache(queryClient, retailerToken, boardToken, brandToken, productToken);
    updateBoardProductsByBrandCache(queryClient, retailerToken, boardToken, brandToken, productToken);
};
var updateBoardProductsCache = function(queryClient, retailerToken, boardToken, productToken) {
    // this cache is used for board products in the board page organized by product
    var fetchBoardProductsKey = getFetchBoardProductsQueryKey(retailerToken, boardToken);
    queryClient.setQueryData(fetchBoardProductsKey, function(cached) {
        if (!cached) {
            return;
        }
        var cachedPage = cached.pages.find(function(page) {
            return page.product_tiles.find(function(tile) {
                var _tile_product;
                return ((_tile_product = tile.product) === null || _tile_product === void 0 ? void 0 : _tile_product.token) === productToken;
            });
        });
        if (cachedPage) {
            cachedPage.product_tiles = cachedPage.product_tiles.filter(function(tile) {
                var _tile_product;
                return ((_tile_product = tile.product) === null || _tile_product === void 0 ? void 0 : _tile_product.token) !== productToken;
            });
        }
        return cached;
    });
};
var updateBoardBrandsCache = function(queryClient, retailerToken, boardToken, brandToken, productToken) {
    // this cache is used for board brands in the board page organized by brand
    var fetchBoardBrandsKey = getFetchBoardBrandsQueryKey(retailerToken, boardToken);
    queryClient.setQueryData(fetchBoardBrandsKey, function(cached) {
        var _cachedPage_brand_token_to_items_brandToken;
        if (!cached) {
            return;
        }
        var cachedPage = cached.pages.find(function(page) {
            return page.brand_token_to_items[brandToken];
        });
        var filteredItems = cachedPage === null || cachedPage === void 0 ? void 0 : (_cachedPage_brand_token_to_items_brandToken = cachedPage.brand_token_to_items[brandToken]) === null || _cachedPage_brand_token_to_items_brandToken === void 0 ? void 0 : _cachedPage_brand_token_to_items_brandToken.items.filter(function(item) {
            var _item_product;
            return ((_item_product = item.product) === null || _item_product === void 0 ? void 0 : _item_product.token) !== productToken;
        });
        if (cachedPage && filteredItems) {
            if (filteredItems.length) {
                cachedPage.brand_token_to_items[brandToken] = IGetBoardItemsGroupByBrandsScrollResponse.IRetailerBoardItemsCollection.build(_object_spread_props(_object_spread({}, cachedPage.brand_token_to_items[brandToken]), {
                    items: filteredItems,
                    product_count: filteredItems.length
                }));
            } else {
                delete cachedPage.brand_token_to_items[brandToken];
            }
        }
        return cached;
    });
};
var updateBoardProductsByBrandCache = function(queryClient, retailerToken, boardToken, brandToken, productToken) {
    // this cache is used for board products in the board page organized by brand
    var fetchBoardProductsByBrandKey = getFetchBoardProductsByBrandQueryKey(retailerToken, boardToken, brandToken);
    queryClient.setQueryData(fetchBoardProductsByBrandKey, function(cached) {
        if (!cached) {
            return;
        }
        var cachedPage = cached.pages.find(function(page) {
            return page.product_tiles.find(function(tile) {
                var _tile_product;
                return ((_tile_product = tile.product) === null || _tile_product === void 0 ? void 0 : _tile_product.token) === productToken;
            });
        });
        if (cachedPage) {
            cachedPage.product_tiles = cachedPage.product_tiles.filter(function(tile) {
                var _tile_product;
                return ((_tile_product = tile.product) === null || _tile_product === void 0 ? void 0 : _tile_product.token) !== productToken;
            });
        }
        return cached;
    });
};
